import { Inject, Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { PIXI_LOADER } from "@karma-games/angular-devkit/src/lib/modules/pixi";
import { Loader } from "@pixi/loaders";
import { GameAnimationData } from "../constants";
import { walletAnimationAssetsMap } from "@karma-games/angular-devkit/src/lib/modules/wallet-animation";
import { timer } from "rxjs";
import { SplashController } from "@karma-games/angular-devkit/src/lib/modules/splash";

@Injectable({ providedIn: "root" })
export class LoadPixiAssetsUseCase implements IUseCase<void, Promise<void>> {
    constructor(@Inject(PIXI_LOADER) private pixiLoader: Loader) {
    }

    execute(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.pixiLoader.add(GameAnimationData.backgroundAnimationName, GameAnimationData.pathToBackgroundAnimationAssets, {
                crossOrigin: "*"
            });
            this.pixiLoader.add(GameAnimationData.foregroundAnimationName, GameAnimationData.pathToForegroundAnimationAssets, {
                crossOrigin: "*"
            });
            this.pixiLoader.add(GameAnimationData.crocoAnimationName, GameAnimationData.pathToCrocoAnimationAssets, {
                crossOrigin: "*"
            });
            this.pixiLoader.add(GameAnimationData.signAnimationName, GameAnimationData.pathToSignAnimationAssets, {
                crossOrigin: "*"
            });
            this.pixiLoader.add(GameAnimationData.glowAnimationName, GameAnimationData.pathToGlowAnimationAssets, {
                crossOrigin: "*"
            });

            // wallet animation assets
            for (let key in walletAnimationAssetsMap) {
                this.pixiLoader.add(key, walletAnimationAssetsMap[key], {
                    crossOrigin: "*"
                });
            }
            const splashController: SplashController = new SplashController();
            this.pixiLoader.onProgress.add((loader: Loader) => {
                splashController.setProgress(loader.progress);
            });
            this.pixiLoader.load(() => {
                // timer to wait for progress bar to fill up
                timer(500).subscribe(() => {
                    resolve();
                });
            });
            this.pixiLoader.onError.add(() => {
                reject();
            });
        });
    }
}
